export default __webpack_public_path__ + "static/media/9eaf73329646c496.cb90e273614dc95faa13320a6eaa04e2.svg";